import React from 'react'
import PropTypes from 'prop-types'
import { useMedia } from 'sb-hooks'
import { links, mixpanel, constants } from 'common/helpers'
import cx from 'classnames'

import { WidthContainer } from 'components/_new/layout/widthContainer'
import Icon from 'components/_new/ui/Icon/Icon'
import Button from 'components/_new/Button/Button'
import Text from 'components/_new/typography/Text/Text'
import Image from 'components/_new/ui/Image/Image'
import Message from 'components/text/Message/Message'

import messages from './messages'
import s from './GiftSetsBanner.scss'

// resolve picture x2
import leftGiftSetImage from './images/left-giftset.png'
// resolve picture x2
import rightGiftSetImage from './images/right-giftset.png'


const GiftSetsBanner = ({ onClose }) => {
  const { isMobile } = useMedia()

  return (
    <div className={s.banner}>
      <WidthContainer>
        <div className={s.content}>
          <button className={s.closeButton} onClick={onClose} type="button">
            <Icon name="closeLight" />
          </button>
          <Text className={s.title} align="center">
            <Message
              className={s.titleLeftPart}
              text={isMobile ? messages.mobileTitle : messages.exceptMobileTitle}
              tag="span"
              html
            />
            <span className={s.discount}>$119.90</span>
          </Text>
          <Image className={cx(s.image, s.left)} {...leftGiftSetImage} />
          <Image className={cx(s.image, s.right)} {...rightGiftSetImage} />
          <Button
            className={s.button}
            size="sm"
            color="brand"
            weight="normal"
            title={messages.buttonTitle}
            to={links.giftSet}
            onClick={() => mixpanel.track(constants.analyticsEvents.giftsetBannerClick)}
            uppercase
          />
        </div>
      </WidthContainer>
    </div>
  )
}

GiftSetsBanner.propTypes = {
  onClose: PropTypes.func.isRequired,
}


export default GiftSetsBanner
